module.exports = __webpack_public_path__ + "img/202509-2_02.40dd0667.jpg";